import React from "react"
import { Visible } from "react-grid-system"
import MobileVersion from "./MobileVersion"
import DesktopVersion from "./DesktopVersion"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import { Container, Row, Col } from "react-grid-system"
import {
  StyledBigHeaderH2,
  StyledClickToDownloadMedium,
  StyledDownloadAnchor,
} from "../Typography"
import { Fade } from "react-reveal"
import report from "../../downloads/abcworld-impact-report-2020.pdf"
import ClickHereToDownloadMobileRight from "../ClickHereToDownload/MobileRight"

const StyledSection = styled.section`
  margin-top: 60px;
  z-index: 3;
  position: relative;
  background-color: #ffffff;
  overflow: hidden;
`

const StyledHeaderWrapper = styled.div`
  margin-bottom: 20px;

  ${breakpoint.md} {
    margin-bottom: 25px;
  }

  ${breakpoint.lg} {
    margin-bottom: 30px;
  }
`

const StyledClickHereToDownloadMobileContainer = styled.div`
  flex: 0 1 70%;
  margin-left: 30%;
  margin-bottom: 40px;

  ${breakpoint.sm} {
    flex: 0 1 50%;
    margin-left: 50%;
  }

  ${breakpoint.md} {
    flex: 0 1 60%;
    margin-left: 40%;
  }
`
const StyledClickHereToDownloadMobileWrapper = styled.div`
  background-color: #0f6495;
  padding-top: 2em;
  padding-bottom: 2em;
  padding-left: 2em;
  padding-right: 30px;
`

const StyledClickHereToDownloadDesktopWrapper = styled.div`
  background-color: #0f6495;
  padding-top: 2em;
  padding-bottom: 2em;
  padding-left: 2em;
  padding-right: 30px;

  margin-bottom: 30px;
`

const OurImpactApproachSection = () => {
  return (
    <StyledSection>
      <StyledHeaderWrapper>
        <Container fluid xs sm md>
          <Row>
            <Col xs={12}>
              <Fade ssrReveal>
                <Visible xs sm md>
                  <StyledBigHeaderH2>Our Impact Approach</StyledBigHeaderH2>
                </Visible>
                <Visible lg xl xxl>
                  <StyledBigHeaderH2>
                    Our Impact <br />
                    Approach
                  </StyledBigHeaderH2>
                </Visible>
              </Fade>
            </Col>
          </Row>
        </Container>
      </StyledHeaderWrapper>

      <Visible xs sm md>
        <Fade ssrReveal right>
          <ClickHereToDownloadMobileRight />
        </Fade>
      </Visible>
      <Visible lg xl xxl>
        <Container>
          <Row>
            <Col lg={6} xl={5} offset={{ lg: 6, xl: 7 }}>
              <Fade ssrReveal right>
                <StyledClickHereToDownloadDesktopWrapper>
                  <StyledClickToDownloadMedium>
                    Click{" "}
                    <StyledDownloadAnchor
                      href={report}
                      download="ABC World Impact Report 2020"
                    >
                      <u>here</u>
                    </StyledDownloadAnchor>{" "}
                    to download the full report
                  </StyledClickToDownloadMedium>
                </StyledClickHereToDownloadDesktopWrapper>
              </Fade>
            </Col>
          </Row>
        </Container>
      </Visible>
      <Visible xs sm md>
        <MobileVersion />
      </Visible>
      <Visible lg xl xxl>
        <DesktopVersion />
      </Visible>
    </StyledSection>
  )
}

export default OurImpactApproachSection
